// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bh-0";
export var headerCellHover = "_bh-1";
export var readCellContainer = "_bh-2";
export var readCellSlot = "_bh-3";
export var rowHoverCheckbox = "_bh-4";
export var rowUnreadIndicator = "_bh-5";
export var searchHighlight = "_bh-8";
export var supportTicketRow = "_bh-6";
export var unreadIndicator = "_bh-7";